import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const GuitarPixelIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M18.6877 27.0312H15.9062V29.8127H18.6877V27.0312Z" fill={fillColor || 'black'} />
      <path
        d="M24.2496 27.0311H21.4682V29.8126H18.6867V32.5941H15.9053V29.8126H13.1238V27.0311H15.9053V24.2497H18.6867V21.4682H21.4682V15.906H24.2496V10.3438H18.6874V13.1252H15.9059V18.6874H13.1245V21.4689H4.78145V24.2504H2V38.1563H4.78145V40.9378H7.56291V43.7192H10.3444V46.5007H24.2503V43.7192H27.0318V35.3755H29.8132V32.5941H35.3754V29.8126H38.1569V24.2504H32.5947V27.0318H27.0324V24.2504H24.251V27.0318L24.2496 27.0311ZM15.9059 40.9371H13.1245V38.1556H10.343V35.3742H7.56157V32.5927H10.343V35.3742H13.1245V38.1556H15.9059V40.9371ZM18.6874 43.7185V40.9371H21.4688V43.7185H18.6874ZM24.2496 38.1563H21.4682V35.3748H24.2496V38.1563Z"
        fill={fillColor || 'black'}
      />
      <path d="M21.469 24.25H18.6875V27.0315H21.469V24.25Z" fill={fillColor || 'black'} />
      <path d="M29.8127 21.4688H27.0312V24.2502H29.8127V21.4688Z" fill={fillColor || 'black'} />
      <path d="M24.2502 21.4688H21.4688V24.2502H24.2502V21.4688Z" fill={fillColor || 'black'} />
      <path d="M32.594 18.6875H29.8125V21.469H32.594V18.6875Z" fill={fillColor || 'black'} />
      <path d="M27.0315 18.6875H24.25V21.469H27.0315V18.6875Z" fill={fillColor || 'black'} />
      <path d="M35.3752 15.9062H32.5938V18.6877H35.3752V15.9062Z" fill={fillColor || 'black'} />
      <path d="M29.8127 15.9062H27.0312V18.6877H29.8127V15.9062Z" fill={fillColor || 'black'} />
      <path d="M38.1565 13.125H35.375V15.9065H38.1565V13.125Z" fill={fillColor || 'black'} />
      <path d="M32.594 13.125H29.8125V15.9065H32.594V13.125Z" fill={fillColor || 'black'} />
      <path d="M35.3752 10.3438H32.5938V13.1252H35.3752V10.3438Z" fill={fillColor || 'black'} />
      <path d="M35.3752 4.78125H32.5938V7.5627H35.3752V4.78125Z" fill={fillColor || 'black'} />
      <path
        d="M40.9372 2V4.78146H38.1565V7.56224H35.375V10.3437H38.1565V13.1252H43.7187V10.3437H46.5002V2H40.9372Z"
        fill={fillColor || 'black'}
      />
      <path d="M38.1565 2H35.375V4.78145H38.1565V2Z" fill={fillColor || 'black'} />
    </svg>
  );
};

export { GuitarPixelIcon };
